import React, { useState, useEffect } from "react";
import { motion as m } from "framer-motion";
import { useAnimationControls } from "framer-motion";
import { interpolate } from "flubber";

const Darklogo = ({ isDark, show, className = "", setIsHovered }) => {
  const controls = useAnimationControls();
  

  const sunPath =
    "M70 49.5C70 60.8218 60.8218 70 49.5 70C38.1782 70 29 60.8218 29 49.5C29 38.1782 38.1782 29 49.5 29C60 29 69.5 38 70 49.5Z";
  const moonPath =
    "M70 49.5C70 60.8218 60.8218 70 49.5 70C38.1782 70 29 60.8218 29 49.5C29 38.1782 38.1782 29 49.5 29C39 45 49.5 59.5 70 49.5Z";

  const [pathD, setPathD] = useState(isDark ? moonPath : sunPath);

  const raysVariants = {
    hidden: {
      strokeOpacity: 0,
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1,
      },
    },
    visible: {
      strokeOpacity: 1,
      transition: {
        staggerChildren: 0.05,
      },
    },
  };

  const rayVariant = {
    hidden: {
      pathLength: 0,
      opacity: 0,
      // Start from center of the circle
      scale: 0,
    },
    visible: {
      pathLength: 1,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 1.5,
        ease: "easeOut",
        // Customize timing for each property
        pathLength: { duration: 0.3 },
        opacity: { duration: 0.2 },
        scale: { duration: 0.3 },
      },
    },
  };

  const shineVariant = {
    hidden: {
      opacity: 0,
      scale: 2,
      strokeDasharray: "20, 1000",
      strokeDashoffset: 0,
      filter: "blur(0px)",
    },
    visible: {
      opacity: [0, 1, 0],
      strokeDashoffset: [0, -50, -100],
      filter: ["blur(2px)", "blur(2px)", "blur(0px)"],
      transition: {
        duration: 1, // ✅ 增加这个字段来控制变形动画的时长
        ease: "linear",
      },
    },
  };

  useEffect(() => {
    const interpolator = interpolate(
      isDark ? sunPath : moonPath,
      isDark ? moonPath : sunPath
    );

    let frame = 0;
    const totalFrames = 30;
    const interval = setInterval(() => {
      const t = frame / totalFrames;
      setPathD(interpolator(t));
      frame++;
      if (frame > totalFrames) clearInterval(interval);
    }, 1000 / 60); // 60fps

    return () => clearInterval(interval);
  }, [isDark, setIsHovered]);

  return (
    <div 
      className="flex items-center justify-center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <m.svg
        strokeWidth="4"
        strokeLinecap="round"
        width={100}
        height={100}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`relative ${className}`}
      >
        <m.path
          variants={shineVariant}
          d={moonPath}
          className={"absolute top-0 left-0 stroke-blue-100 "}
          initial="hidden"
          animate={isDark ? "visible" : "hidden"}
        />

        <m.g
          variants={raysVariants}
          initial="hidden"
          animate={!isDark ? "visible" : "hidden"}
          className="stroke-6 stroke-yellow-600 "
          style={{ strokeLinecap: "round" }}
        >
          <m.path
            className="origin-center"
            variants={rayVariant}
            d="M50 2V11"
          />
          <m.path variants={rayVariant} d="M85 15L78 22" />
          <m.path variants={rayVariant} d="M98 50H89" />
          <m.path variants={rayVariant} d="M85 85L78 78" />
          <m.path variants={rayVariant} d="M50 98V89" />
          <m.path variants={rayVariant} d="M23 78L16 84" />
          <m.path variants={rayVariant} d="M11 50H2" />
          <m.path variants={rayVariant} d="M23 23L16 16" />
        </m.g>

        <m.path
          d={sunPath}
          fill="transparent"
          transition={{ duration: 1, type: "spring" }}
          initial={{ fillOpacity: 0, strokeOpacity: 0 }}
          animate={
            isDark
              ? {
                  d: moonPath,
                  rotate: -360,
                  scale: 2,
                  stroke: "var(--color-blue-400)",
                  fill: "var(--color-blue-400)",
                  fillOpacity: 0.35,
                  strokeOpacity: 1,
                  transition: {
                    duration: 1, // ✅ 设置更长时间
                    delay: 0.1,
                    ease: "easeInOut",
                  },
                }
              : {
                  d: sunPath,
                  rotate: 0,
                  stroke: "var(--color-yellow-600)",
                  fill: "var(--color-yellow-600)",
                  fillOpacity: 0.35,
                  strokeOpacity: 1,
                  transition: {
                    duration: 1.5, // ✅ 同样设置
                    ease: "easeInOut",
                  },
                }
          }
        />
      </m.svg>
    </div>
  );
};

export default Darklogo;
